module.exports = __webpack_public_path__ + "static/img/kn.bde74c6d.svg";